import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=14e54807&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=ts"
export * from "./CategoryCard.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=14e54807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e54807",
  null
  
)

export default component.exports